
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core';

const styles = () => ({
  weekDays: {
    fontWeight: 'bold',
    display: 'flex',
    flexWrap: 'wrap',
    position: 'relative',
    zIndex: 1,
    background: '#111',
    borderBottom: '2px solid #000',
    color: 'rgba(255,255,255,0.8)',
    padding: '5px 0',
    '& strong': {
      flex: '1 0 14.28%',
      maxWidth: 'calc(100% / .7)',
      textAlign: 'center',
    },
  },
});

const CalHeaderWeekDays = (props) => {

  const { classes } = props;
  return (
    <header className={classes.weekDays}>
      {props.days.map((weekday) => (
        <strong key={weekday}>{weekday}</strong>
      ))}
    </header>
  );
};

CalHeaderWeekDays.propTypes = {
  classes: PropTypes.object,
  days: PropTypes.array,
};

export default compose(
  withStyles(styles),
)(CalHeaderWeekDays);

